export default __webpack_public_path__ + "static/media/theme_retro.38c9d5c0.jpg";